import { API_BASE_URL } from "./config";

export async function fetchAbout() {
  try {
    const res = await fetch(`${API_BASE_URL}/api/user/pages/about`);
    return await res.json();
  } catch (error) {
    return { error: "An error Occured!" };
  }
}
export async function fetchArticle(id) {
  try {
    const res = await fetch(`${API_BASE_URL}/api/admin/blogs/${id}`);
    return await res.json();
  } catch (error) {
    return { error: "An error Occured!" };
  }
}
export async function fetchArticles(limit, currentPage) {
  try {
    const res = await fetch(
      `${API_BASE_URL}/api/admin/blogs?page=${currentPage}&limit=${limit}`
    );
    return await res.json();
  } catch (error) {
    return { error: "An error Occured!" };
  }
}
